import { Controller } from "@hotwired/stimulus"

// Navega para `url?param=valor` ao trocar o valor do elemento (select/input).
// Usa Turbo/Turbo quando disponível; senão, location padrão.
export default class extends Controller {
  static values = { url: String, param: String }

  navigate(event) {
    const target = `${this.urlValue}?${this.paramValue}=${encodeURIComponent(event.target.value)}`
    if (typeof Turbo !== "undefined") {
      Turbo.visit(target)
    } else {
      window.location.assign(target)
    }
  }
}
